import { PropsWithChildren, ReactNode } from 'react'
import { mdiHelpCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useIntl } from 'react-intl'

import ConfirmModal from 'components/Modal/ConfirmModal'
import { commonMessages } from 'app/i18n/messages'

interface ConfirmDeleteModalProps {
  handleConfirm: () => void
  handleDiscard: () => void
  isOpen: boolean
  title: ReactNode
}

function ConfirmDeleteModal({
  children,
  handleConfirm,
  handleDiscard,
  isOpen,
  title,
}: PropsWithChildren<ConfirmDeleteModalProps>) {
  const { formatMessage } = useIntl()

  return (
    <>
      <ConfirmModal
        isOpen={isOpen}
        onDiscard={handleDiscard}
        icon={<Icon path={mdiHelpCircleOutline} size="48px" />}
        title={title}
        discardBtnTitle={formatMessage(commonMessages.cancel)}
        confirmBtnTitle={formatMessage(commonMessages.delete)}
        onConfirm={handleConfirm}
        variant="errorFilled"
      >
        {children}
      </ConfirmModal>
    </>
  )
}

export default ConfirmDeleteModal
